import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    getBarProfitReportById
} from './actions/actions'

import {
    formatBarProfitInputSetInputValue,
    formatBoxPlotBarProfitInputSetInputValue,
} from '../utils'

import BoxPlot from '../../../shared/components/BoxPlot/BoxPlot';
import BoxAndWhiskerDataPoint from '../../../shared/components/BoxPlot/BoxAndWhiskerDataPoint';
import {format} from 'd3-format';

import SectionCard from './components/SectionCard'
import NavBar from './components/NavBar'
import BeverageProgramGradeContainer from './components/BeverageProgramGradeContainer'

export class BarProfitReport extends Component {

    componentDidMount() {
        this.props.dispatch(getBarProfitReportById(this.props.dataId));
    }

    componentDidUpdate() {
        $.localScroll({
            lazy: true,
            duration: 1000,
            offset: 0,
        });
    }

    getBoxAndWhiskerPlotDataPoints(setName) {
        const setData = this.props.state.barProfitReport.dataBySetName[setName];

        return [
            new BoxAndWhiskerDataPoint({
                name: 'Beer',
                primaryColor: '#e05721',
                secondaryColor: '#f09a66',
                ...setData.beer
            }),
            new BoxAndWhiskerDataPoint({
                name: 'Spirits',
                primaryColor: '#5b908f',
                secondaryColor: '#a3cdc6',
                ...setData.spirits
            }),
            new BoxAndWhiskerDataPoint({
                name: 'Wine',
                primaryColor: '#7d354f',
                secondaryColor: '#ac8593',
                ...setData.wine
            }),
            new BoxAndWhiskerDataPoint({
                name: 'Total',
                primaryColor: 'black',
                secondaryColor: 'grey',
                ...setData.total
            })
        ];
    }

    getBoxAndWhiskerPlot(setName) {
        let data = this.getBoxAndWhiskerPlotDataPoints(setName);

        let formatFunction = function(value) {

            return formatBoxPlotBarProfitInputSetInputValue(setName, value);
        };

        let margins = {top: 10, right: 0, bottom: 40, left: 65};
        let containerId = setName + '-boxplot-container';

        return (
            <BoxPlot
                containerId={containerId}
                width={600}
                height={400}
                margins={margins}
                data={data}
                whiskerColor={'rgba(220, 220, 220, .7)'}
                whiskerWidth={15}
                boxWidth={45}
                pointRadius={8}
                pointOfInterestThickness={4}
                tooltipFormatFunction={formatFunction}
                yValueFormatFunction={formatFunction}
            />
        );
    }

    render() {
        const { state, dispatch } = this.props;

        const barProfitReport = state.barProfitReport;

        if (barProfitReport.errorMessage) {
            // need to list the id's ahead of time for $.localScroll
            return (
                <div className="bar-profit-error-wrapper">
                    <div style={ { minHeight: '100vh' } } className="bar-profit-landing section">
                        <div className="bar-profit-landing-wrapper">
                            <div className="bar-profit-title-logo">
                                <div className="logo-wrapper">
                                    <a className="brand-logo transition" href="https://www.bevspot.com">
                                        <span className="bevicon bevico-bevspot-logo transition"></span>
                                        <span className="bevicon bevico-logo-text transition"></span>
                                    </a>
                                    <h1 className="bar-profit-logo">
                                        <div className="top-rule"></div>
                                        <div className="top-rule second-top-rule"></div>
                                        Bar Profit Analysis
                                    </h1>
                                </div>
                            </div>
                            <div className="opening-image">
                                <img style={ { width: '100%' } } src="/static/img/barprofit/SliderCircle.gif"/>
                            </div>
                            <div className="bar-profit-description bar-profit-title pad-bt-md">
                                <h2> {barProfitReport.errorMessage}... </h2>
                                <p>Find out<strong> where your beverage program ranks</strong> nation-wide.</p>
                                <a className="bar-profit-button" href="/bar-profit-tool/">Create a new report?</a>
                            </div>
                        </div>
                    </div>
                    <div id='overview-section-card' style={{margin: '0px'}}></div>
                    <div id='inventory-label' ></div>
                    <div id='ordering-label' ></div>
                    <div id='sales-label' ></div>
                    <div id='efficiency-section-card' ></div>
                    <div id='pour-cost-section-card' ></div>
                    <div id='next-steps-wrapper' ></div>
                </div>
            );
        }

        return (
            <div className="bar-profit-report-container">
                <NavBar dataId= { this.props.dataId } />

                <div className="container bar-profit-report-wrapper">
                    <SectionCard
                        id={'overview-section-card'}
                        header={

                            <BeverageProgramGradeContainer letterGrade={ barProfitReport.letterGrade } />
                        }
                        headerClasses={ 'grade-' + barProfitReport.letterGrade[0] }
                        body={
                            <div className="row">
                                <div className="col-xs-12 col-sm-4 col-sm-offset-1 text-right">
                                    <div className="report-label">
                                        Annual Sales
                                        <div className="report-input-number">
                                            { formatBarProfitInputSetInputValue("annualSales", barProfitReport.dataBySetName.annualSales.total.you) }
                                        </div>
                                    </div>
                                    <div className="report-label">
                                        Sitting Inventory
                                        <div className="report-input-number">
                                            { formatBarProfitInputSetInputValue("averageSittingInventory", barProfitReport.dataBySetName.averageSittingInventory.total.you) }
                                        </div>
                                    </div>
                                    <div className="report-label">
                                        Weekly Usage
                                        <div className="report-input-number">
                                            { formatBarProfitInputSetInputValue("weeklyUsage", barProfitReport.dataBySetName.weeklyUsage.total.you) }
                                        </div>
                                    </div>
                                    <div className="report-label">
                                        Pour Cost Percent
                                        <div className="report-input-number">
                                            { formatBarProfitInputSetInputValue("pourCostPercent", barProfitReport.dataBySetName.pourCostPercent.total.you) }
                                        </div>
                                    </div>
                                    <div className="report-label">
                                        Inventory Efficiency
                                        <div className="report-input-number">
                                            { formatBarProfitInputSetInputValue("inventoryWeeks", barProfitReport.dataBySetName.inventoryWeeks.total.you) }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <p className="intro">This analysis represents what your business looks like–and how it's performing.</p>
                                    <p>Improving your bar's profitability comes down to knowing the numbers. And without the ability to analyze them, you won't be able to connect the dots with the rest of your beverage program, making adjustments that will save you time, money or both. </p>
                                    <p><strong>Let's take a closer look at your bar's results ...</strong></p>
                                </div>
                                <div className="col-xs-12 col-sm-1">
                                </div>
                            </div>
                        }
                    />

                    <div className="bar-profit-results-wrapper">
                        <div className="row">
                            <div className="col-xs-12 col-sm-6">
                                <h6 className="pad-bt-xs">KEY</h6>
                                <p className="intro"><strong>Our box and whisker plots</strong> represent distributions of data, separated by the middle 50% (darker blocks) and the top and bottom 25% (light blocks). The white line represents the median.</p>
                                <p>The darker blocks (middle 50%) <strong>represent a “target” range</strong> you might want to strive for, based on our industry data.</p>
                                <p className="tip"><strong>Tip:</strong><br/> Hover over the graphs below to see distribution breakdowns.</p>
                            </div>
                            <div className="col-xs-12 text-left col-sm-6">
                                <img style={ {width: '100%'} } src="/static/img/barprofit/bar-profit-key.png"/>
                            </div>
                        </div>
                     </div>

                    <div className="bar-profit-results-wrapper">

                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-8">
                                <h6 className="">Industry Benchmarks</h6>
                                <h2 className="result-title">How do you rank against base industry trends?</h2>
                            </div>
                        </div>

                        <div id="inventory-label" className="row pad-bt-md">
                            <div className="col-xs-12">
                                <h3 className="rule-top">Your Sitting Inventory</h3>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-8">
                                { this.getBoxAndWhiskerPlot("averageSittingInventory") }
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-4">
                                <h6 className="graph-title">Average Sitting Inventory by Category</h6>
                                <p> Average sitting inventory distribution varies greatly across beverage categories, and your score will depend on the specific category you specialize in, but you can use this as a comparison to match your bar's sitting inventory with the levels we see industry-wide.</p>
                            </div>
                        </div>

                        <div id="ordering-label" className="row pad-bt-md">
                            <div className="col-xs-12">
                                <h3 className="rule-top">Your Weekly Usage</h3>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-8">
                                { this.getBoxAndWhiskerPlot("weeklyUsage") }
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-4">
                                <h6 className="graph-title">Average Weekly Usage by Category</h6>
                                <p>Tracking usage is critical in understanding product variance, product performance and how your bar is performing financially. Use this chart to see how your inventory usage measures up to other bars in the industry.</p>
                            </div>
                        </div>

                        <div id="sales-label" className="row pad-bt-sm">
                            <div className="col-xs-12">
                                <h3 className="rule-top">Your Annual Sales</h3>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-8">
                                { this.getBoxAndWhiskerPlot("annualSales") }
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-4">
                                <h6 className="graph-title">Average Annual Sales by Category</h6>
                                <p>Understanding your bar's sales data, and comparing these numbers with your inventory and ordering data, is a key indicator of your bar's performance. But what does your sales data look like compared to the competition?</p>
                            </div>
                        </div>
                    </div>

                    <SectionCard
                        id="efficiency-section-card"
                        header={
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-8">
                                    <h6 className="section-header">KPI: Inventory Efficiency</h6>
                                    <h2 className="result-title">
                                        { barProfitReport.analysisBySetName.inventoryWeeks.shortDescription }
                                    </h2>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-4 text-center">
                                    <span className={ "bevicon bevico-face-" + barProfitReport.analysisBySetName.inventoryWeeks.classId }></span>
                                </div>
                            </div>
                        }
                        headerClasses={ 'recommendation-' + barProfitReport.analysisBySetName.inventoryWeeks.classId }
                        body={
                            <div className="row">

                                <div className="col-xs-12 col-sm-12 col-md-3">
                                    <h6 className="graph-title">Average Weeks&rsquo; Worth of Sitting Inventory by Category</h6>
                                    <p className="caption">Hover over the blocks to see how you compare.</p>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-9 pad-bt-sm">
                                    { this.getBoxAndWhiskerPlot("inventoryWeeks") }
                                </div>

                                <div className="col-xs-12 col-sm-12">
                                    <h3 className="rule-top">Making Sense of the Numbers</h3>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6">
                                    <p>The most successful bars we work with have the lowest levels of sitting inventory&mdash;they understand how these numbers affect the overall efficiency of their beverage program.</p>

                                    <p>Across all of our customers, typical inventory efficiency varies widely by category. The average bar has approximately <strong>2.1</strong> weeks of beer inventory, <strong>6</strong> weeks of spirit inventory and <strong>4.2</strong> weeks of wine inventory.</p>

                                    <p>Meanwhile, the bars with the most efficient beverage programs sit on less than <strong>1.5</strong> weeks of beer inventory, <strong>4</strong> weeks of spirit inventory and <strong>3</strong> weeks of wine inventory.</p>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6">
                                    <p>Though we usually recommend you target <strong>2-3 weeks</strong> of sitting inventory for individual items, we know that actual practices vary between bars. We also know that such variance is related not just to management proficiency but also to the product mix unique to each beverage program, as well as the volume of product sold.</p>

                                    <p>Use these numbers achieved by our most successful customers as targets for your beverage program. By running a lean inventory program, you can reduce your bar’s variance, save your staff time and increase profits for your business.</p>
                                </div>
                            </div>
                        }
                    />

                    <SectionCard
                        id="pour-cost-section-card"
                        header={
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-8">
                                    <h6 className="section-header">KPI: Pour Cost</h6>
                                    <h2 className="result-title">{  barProfitReport.analysisBySetName.pourCostPercent.shortDescription }</h2>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-4 text-center">
                                    <span className={ "bevicon bevico-face-" + barProfitReport.analysisBySetName.pourCostPercent.classId }></span>
                                </div>
                            </div>
                        }
                        headerClasses={ 'recommendation-' + barProfitReport.analysisBySetName.pourCostPercent.classId }
                        body={
                            <div className="row">

                                <div className="col-xs-12 col-sm-12 col-md-3">
                                    <h6 className="graph-title">Average Pour Cost by Category</h6>
                                    <p className="caption">Hover over the blocks to see how you compare.</p>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-9 pad-bt-sm">
                                    { this.getBoxAndWhiskerPlot("pourCostPercent") }
                                </div>

                                <div className="col-xs-12 col-sm-12">
                                    <h3 className="rule-top">What does this mean for you?</h3>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6">
                                    <p>
                                        Pour costs are an essential barometer for bar profitability, and since running a
                                        bar can be costly, controlling pour costs can account for the difference between
                                        a wildly successful bar and a failing one.
                                    </p>
                                    <p>
                                        Among our customers, we found that the middle range of BevSpot bars have total
                                        average pour costs of around <strong>18-24%</strong>. The median bar sits at a pour cost of just
                                        above 20%.
                                    </p>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6">
                                    <p>
                                        When broken down by category, median pour costs across our customers are <strong>24%</strong> for
                                        beer, <strong>15%</strong> for spirits and cocktails, and <strong>28%</strong> for wine. The lowest quartile of pour costs&mdash;our best performing customers&mdash;are at or below <strong>20%</strong> for beer, <strong>14%</strong> for spirits and cocktails, and <strong>22%</strong> for wine.
                                    </p>
                                    <p>
                                        When broken down by product category&mdash;beer, wine, spirits&mdash;these numbers obviously
                                        vary, and your bar's pour cost will depend on which of those categories you serve
                                        the most. But regardless of your speciality, even a small improvement in pour
                                        costs over one year can result in huge savings.
                                    </p>
                                </div>
                            </div>
                        }
                    />

                    <div id="next-steps-wrapper" className="bar-profit-results-wrapper bar-profit-results-header">
                        <div className="row">
                            <div className="col-xs-12 col-sm-10 pad-tp-xs">
                                <h6 className="section-header">Summary &amp; Recommendations</h6>
                                <h2>Your Tips for Optimizing Profit</h2>
                            </div>
                        </div>
                    </div>

                    <div className="bar-profit-results-wrapper">

                        <div className="row pad-bt-sm">
                            <div className="col-xs-12 col-sm-7">
                                <p className="intro">Based on your score, we&rsquo;ve pulled together some custom suggestions and resources for maximizing your bar&rsquo;s profitability.</p>
                            </div>
                            <div className="col-xs-12 col-sm-1"></div>
                            <div className="col-xs-12 col-sm-4">
                                <p><strong>Plus:</strong> our consultants are always available for a risk-free consultation about your numbers. Feel free to <a href="https://www.bevspot.com/bar-profit-analysis-consultation/" target="_blank">schedule yours</a> today!</p>
                            </div>
                        </div>

                        <div className="row pad-bt-sm results-text">
                            <div className="col-xs-12 col-md-12">
                                <h3 className="rule-top">Pour Cost</h3>
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <p className="result-subtitle" dangerouslySetInnerHTML={{ __html: barProfitReport.analysisBySetName.pourCostPercent.summary }}></p>
                            </div>
                            <div className="col-xs-12 col-sm-8">
                                { barProfitReport.analysisBySetName.pourCostPercent.recommendations.map(
                                    (recommendation, index) => (
                                        <p key={ index } dangerouslySetInnerHTML={{ __html: recommendation }}></p>
                                    )
                                )}
                            </div>
                            <div className="col-xs-12 col-sm-4">
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <div className="resource-blog-link resource-blog-link-text">
                                    <a href="https://www.bevspot.com/2015/10/13/bar-management-pricing-drinks-pour-costs/" target="_blank">
                                        Pricing Drinks to Achieve Successful Pour Costs
                                    </a>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <div className="resource-blog-link">
                                    <a href="https://www.bevspot.com/2015/10/13/bar-management-pricing-drinks-pour-costs/" target="_blank">
                                        <img src="/static/img/barprofit/bar-profit-blog-pricing-drinks.jpg"/>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="row pad-bt-sm results-text">
                            <div className="col-xs-12 col-md-12">
                                <h3 className="rule-top">Inventory Efficiency</h3>
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <p className="result-subtitle" dangerouslySetInnerHTML={{ __html: barProfitReport.analysisBySetName.inventoryWeeks.summary }}></p>
                            </div>

                            <div className="col-xs-12 col-sm-8">
                                { barProfitReport.analysisBySetName.inventoryWeeks.recommendations.map(
                                    (recommendation, index) => (
                                        <p key={ index } dangerouslySetInnerHTML={{ __html: recommendation }}></p>
                                    )
                                )}
                            </div>
                            <div className="col-xs-12 col-sm-4">
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <div className="resource-blog-link resource-blog-link-text">
                                    <a href="https://www.bevspot.com/2015/07/27/bar-management-3-ways-to-think-about-sitting-inventory/" target="_blank">
                                        Three Ways to Think About Sitting Inventory
                                    </a>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-4">
                                <div className="resource-blog-link">
                                    <a href="https://www.bevspot.com/2015/07/27/bar-management-3-ways-to-think-about-sitting-inventory/" target="_blank">
                                        <img src="/static/img/barprofit/bar-profit-blog-sitting-inventory.jpg"/>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="row pad-bt-xs">
                            <div className="col-xs-12 col-sm-12">
                                <h3 className="rule-top">Additional Resources</h3>
                            </div>
                            <div className="col-xs-12 col-sm-8 pad-bt-xs">
                                <p>Based on your numbers, we&rsquo;ve picked out some articles from <a href="https://www.bevspot.com/blog/" target="_blank">The BevSpot Blog</a> that should be helpful in thinking about increasing your profitability.</p>
                            </div>
                            <div className="col-xs-12">
                                <div className="row resources-blog-wrapper">
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="resource-blog-link">
                                            <a href="https://bevspot.com/blog/bar-inventory-usage-beginners/" target="_blank">
                                                <img src="/static/img/barprofit/bar-profit-blog-inventory-usage.jpg"/>
                                            </a>
                                        </div>
                                        <div className="resource-blog-link resource-blog-link-text">
                                            <a href="https://bevspot.com/blog/bar-inventory-usage-beginners/" target="_blank">
                                                Calculating Inventory Usage
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="resource-blog-link">
                                            <a href="https://www.bevspot.com/2016/04/27/2075/" target="_blank">
                                                <img src="/static/img/barprofit/bar-profit-blog-proven-tips.jpg"/>
                                            </a>
                                        </div>
                                        <div className="resource-blog-link resource-blog-link-text">
                                            <a href="https://www.bevspot.com/2016/04/27/2075/" target="_blank">
                                                11 Proven Tips to Control Your Beverage Costs
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="resource-blog-link">
                                            <a href="https://www.bevspot.com/2016/06/30/calculate-actual-beverage-cost/" target="_blank">
                                                <img src="/static/img/barprofit/bar-profit-blog-actual-cost.jpg"/>
                                            </a>
                                        </div>
                                        <div className="resource-blog-link resource-blog-link-text">
                                            <a href="https://www.bevspot.com/2016/06/30/calculate-actual-beverage-cost/" target="_blank">
                                                How to Calculate Your Actual Beverage Cost
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="resource-blog-link">
                                            <a href="https://www.bevspot.com/2016/03/28/managing-sales-profitability-bar-business/" target="_blank">
                                                <img src="/static/img/barprofit/bar-profit-blog-managing-sales.jpg"/>
                                            </a>
                                        </div>
                                        <div className="resource-blog-link resource-blog-link-text">
                                            <a href="https://www.bevspot.com/2016/03/28/managing-sales-profitability-bar-business/" target="_blank">
                                                Managing Sales and Profitability For Your Bar
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="resource-blog-link">
                                            <a href="https://www.bevspot.com/2016/08/09/pour-cost-variance-and-sitting-inventory-why-they-matter/" target="_blank">
                                                <img src="/static/img/barprofit/bar-profit-blog-why.jpg"/>
                                            </a>
                                        </div>
                                        <div className="resource-blog-link resource-blog-link-text">
                                            <a href="https://www.bevspot.com/2016/08/09/pour-cost-variance-and-sitting-inventory-why-they-matter/" target="_blank">
                                                Pour Cost, Variance and Sitting Inventory—Why They Matter
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        <div className="resource-blog-link">
                                            <a href="https://www.bevspot.com/2016/08/08/3-essential-math-equations-running-bar-restaurant/" target="_blank">
                                                <img src="/static/img/barprofit/bar-profit-blog-math-equations.jpg"/>
                                            </a>
                                        </div>
                                        <div className="resource-blog-link resource-blog-link-text">
                                            <a href="https://www.bevspot.com/2016/08/08/3-essential-math-equations-running-bar-restaurant/" target="_blank">
                                                7 Bar and Restaurant Math Equations to Boost Profitability
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="bar-profit-results-wrapper bar-profit-cta dark">
                        <div className="row">
                            <div className="col-xs-12 col-sm-10">
                                <h6 className="section-header">Shameless Plug</h6>
                                <h2>If you like this report,<br/> we think you&rsquo;ll love BevSpot ...</h2>
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <h3>But even if you&rsquo;re not interested in our software, we&rsquo;d still love to chat.</h3>
                                <p className="intro">Our hospitality consultants are here to walk you through your report and make sense of it all, plus provide feedback about any questions you might have.</p>
                            </div>
                            <div className="col-xs-12 col-sm-6 text-center">
                                <p>&nbsp;</p>
                                <a className="bar-profit-button" href="https://www.bevspot.com/bar-profit-analysis-consultation/" target="_blank">Schedule a Consultation</a>
                                <br/>
                                <br/>
                                <br/>
                                Or get started by checking out <a href="https://www.bevspot.com" target="_blank">BevSpot</a>
                            </div>
                        </div>
                    </div>

                    <div className="bar-profit-share-wrapper">
                        <div className="row">
                            <div className="col-xs-12">
                                <h2>Share your Bar Profit Analysis!</h2>
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <h3>Have a co-worker, boss, manager or proud mom who would be interested in your report?</h3>
                                <p>You can send them a direct link that will allow them to see your results.</p>
                                <div>
                                    <a
                                        href={ "mailto:?&subject=I just graded my bar with BevSpot—see how I scored&body=I%20used%20BevSpot's%20new%20Bar%20Profit%20Analysis%20Tool%20to%20grade%20my%20beverage%20program.%20%0A%0ACheck%20out%20my%20score%20here%20(%20https%3A//app.bevspot.com/bar-profit-tool/?data-id=" + this.props.dataId + "%20).%20You%20can%20see%20how%20my%20inventory%20efficiency%20levels%20and%20pour%20costs%20compare%20to%20other%20bars%20and%20restaurants%20across%20the%20industry.%0A%0AWant%20to%20see%20your%20score?%20Take%20a%20look%3A%20app.bevspot.com/bar-profit-tool/" }
                                        target="_blank"
                                        className="bar-profit-email-button"
                                    >
                                        <span className="bevicon bevico-email">
                                        </span>
                                        Share via email
                                    </a>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-6">

                                <h3>Just want to spread the word?</h3>
                                <p>Share it!</p>

                                <div>
                                    <a
                                        href="https://www.facebook.com/sharer/sharer.php?u=http%3A//hubs.ly/H04hN360"
                                        target="_blank"
                                        className="bar-profit-facebook-button"
                                    >
                                        <span className="bevicon bevico-social-facebook">
                                        </span>
                                        Share on Facebook
                                    </a>
                                </div>
                                <div>
                                    <a
                                        href="https://www.linkedin.com/shareArticle?mini=true&url=http%3A//hubs.ly/H04hNzG0&title=&summary=&source="
                                        target="_blank"
                                        className="bar-profit-linkedin-button"
                                    >
                                        <span className="bevicon bevico-social-linkedin">
                                        </span>
                                        Share on LinkedIn
                                    </a>
                                </div>
                                <div>
                                    <a
                                        href="https://twitter.com/home?status=I%20just%20graded%20my%20beverage%20program%20on%20%40BevSpot%27s%20Bar%20Profit%20Analysis%20Tool.%20How%20does%20yours%20compare?%20http%3A//hubs.ly/H04hNBw0"
                                        target="_blank"
                                        className="bar-profit-twitter-button"
                                    >
                                        <span className="bevicon bevico-twitter">
                                        </span>
                                        Share on Twitter
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BarProfitReport.propTypes = {
    dataId: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
    return {
        state: state
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BarProfitReport);
